/**
 * TODO: Write this file out of the codebase.
 *
 * Not really great practice, but a quick fix to avoid global variables and
 * cyclic dependencies during the ES6 migration.
 */

// Formerly window.currentOpenTodoId

/** @type {string | undefined} */
let currentOpenTodoId;

export const getCurrentOpenToDoId = () => currentOpenTodoId;

/** @param {string | undefined} id */
export const setCurrentOpenToDoId = (id) => {
  currentOpenTodoId = id;
};

// Formerly window.datepickerRangeChanged

/** @type {boolean} */
let datepickerRangeChanged = false;

/** @param {boolean} value */
export const setDateRangePickerChanged = (value) => {
  datepickerRangeChanged = value;
};

export const getDateRangePickerChanged = () => datepickerRangeChanged;
